<template>
  <div class="card content-list-item">
    <div class="card-header text-center font-weight-bold">
      <template v-if="id === 'default'">
        Default Feedback
      </template>
      <template v-else>
        Combo Score {{ index }}
      </template>
    </div>
    <div class="card-body">
      <label class="font-weight-bold" for="">Feedback</label>
      <template v-if="!generatingAIFeedback">
        <QuillEditor v-model:content="tempFeedback" :contentType="'html'" :options="editorOpts"
                     @textChange="textChange()"/>
      </template>
      <template v-else>
        <div class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Generating Feedback...</span>
          </div>
        </div>
      </template>
      <div v-if="showRegenerateButton" class="mt-4">
        <button class="btn btn-default" type="button" v-on:click="regenerateFeedback(index)">regenerate feedback
        </button>
      </div>
      <div class="form-group mt-4 row">
        <div class="col-sm-6">
          <div v-for="(combo, index) in comboSettings" :key="index">
            <div style="display:flex;">
              <div v-for="(opt, j) in combo" :key="j">
                <label>
                  <input v-model="comboSettings[index][j].value" type="checkbox"
                         v-on:change="updateComboSettingsInParent()">
                  {{ alphabet[j] }}
                </label>
              </div>
              <div>
                <a v-if="index > 0" href="#" v-on:click.prevent="removeComboSettingRow(index)">X</a>
              </div>
            </div>
          </div>
          <a v-if="id !== 'default'" href="#" v-on:click.prevent="addCombo()">+ Add another combination</a>
        </div>
        <div class="col-sm-3">
          <label class="control-label">Flow Hook</label>
          <input :placeholder="'choice-' + (index + 1)" :value="flow" class="form-control" type="text"
                 @input="$emit('update:flow', $event.target.value)">
        </div>
        <div class="col-sm-3">
          <label class="control-label">Outcome Trigger</label>
          <input :placeholder="'event-' + (index + 1)" :value="trigger" class="form-control" type="text"
                 @input="$emit('update:trigger', $event.target.value)">
        </div>
      </div>
      <div class="form-group card-metrics">
        <div class="col-9 pl-0 meters">
          <label class="control-label" for="metrics">Meter Effects</label>
          <div class="meter-wrap">
            <div v-for="meter in meters" :key="meter.id" class="col">
              <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
              <input :id="meter.id" :value="meter.value" class="form-control" type="number"
                     @input="updateMeterValuesInParent(meter.id, $event.target.value)">
            </div>
          </div>
        </div>
        <div class="col-3 pr-0 col-rmv">
          <button class="btn btn-danger btn-block btn-remove" type="button"
                  @click="remove(index)">Remove
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {ALPHABET, EDITOR_CONFIG_LITE} from '../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  props: [
    'id', 'index', 'meters', 'feedback',
    'flow', 'trigger', 'responses',
    'combinations', 'defaultComboOpts', 'generateFeedback', 'showRegenerateButton'
  ],
  components: {
    QuillEditor
  },
  data() {
    const opts = _.cloneDeep(this.combinations) || [_.cloneDeep(this.defaultComboOpts)]
    return {
      comboSettings: opts,
      alphabet: ALPHABET,
      tempFeedback: this.feedback,
      editorOpts: EDITOR_CONFIG_LITE,
      generatingAIFeedback: this.generateFeedback || false
    }
  },
  methods: {
    remove: function (index) {
      this.$emit('removecombo', index)
    },
    addCombo: function () {
      this.comboSettings.push(_.cloneDeep(this.defaultComboOpts))
      this.updateComboSettingsInParent()
    },
    removeComboSettingRow: function (index) {
      this.comboSettings.splice(index, 1)
      this.updateComboSettingsInParent()
    },
    updateComboSettingsInParent: function () {
      const settingData = {id: this.id, settings: this.comboSettings}
      this.$emit('patchcombosettings', settingData)
    },
    updateMeterValuesInParent: function (meterId, value) {
      const meterData = {id: this.id, meterId: meterId, value: value}
      this.$emit('patchmetervals', meterData)
    },
    textChange() {
      this.$emit('update:feedback', this.tempFeedback)
    },
    regenerateFeedback() {
      this.generatingAIFeedback = true
      this.$emit('regeneratefeedback', this.index)
    }
  },
  watch: {
    defaultComboOpts: function (newVal, oldVal) {
      if (this.id == 'default') {
        return false
      }
      if (newVal.length > oldVal.length) {
        this.comboSettings.forEach((cs) => {
          cs.push({value: false})
        })
      }
      if (newVal.length < oldVal.length) {
        this.comboSettings.forEach((cs) => {
          cs.splice(-1, 1)
        })
      }
      this.updateComboSettingsInParent()
    },
    feedback: function (newVal, oldVal) {
      this.tempFeedback = newVal
      this.generatingAIFeedback = false
    }
  }
}
</script>
